/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3ViantAdelphicConfiguration } from '../models/V3ViantAdelphicConfiguration';
import { HttpFile } from '../http/http';

export class V1OrderLineViantAdelphicConfigurationSet {
    'requestId'?: string;
    'userId'?: string;
    'timestamp'?: Date;
    'orderLineId'?: string;
    'orgId'?: string;
    'viantAdelphicConfiguration'?: V3ViantAdelphicConfiguration;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "orderLineId",
            "baseName": "order_line_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "viantAdelphicConfiguration",
            "baseName": "viant_adelphic_configuration",
            "type": "V3ViantAdelphicConfiguration",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineViantAdelphicConfigurationSet.attributeTypeMap;
    }

    public constructor() {
    }
}

